import { useEffect, type RefObject } from 'react';

/** Fit the mobile dock above the software keyboard, including iOS standalone.
 * Pinch zoom remains under the user's control; it must not resize the layout.
 */
export function useAssistantViewport(panel: RefObject<HTMLElement>, active: boolean) {
  useEffect(() => {
    const element = panel.current;
    const viewport = window.visualViewport;
    if (!active || !element || !viewport) return;
    const update = () => {
      if (Math.abs(viewport.scale - 1) > 0.01 || viewport.height <= 0) return;
      element.style.setProperty('--assistant-viewport-height', `${viewport.height}px`);
      element.style.setProperty('--assistant-viewport-top', `${viewport.offsetTop}px`);
    };
    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
      element.style.removeProperty('--assistant-viewport-height');
      element.style.removeProperty('--assistant-viewport-top');
    };
  }, [active, panel]);
}
